export interface ObjectWithThumbnail {
  thumbFile: File | Blob;
}

export const isObjWithThumbnail = (obj: object): obj is ObjectWithThumbnail => {
  return 'thumbFile' in obj && obj.thumbFile instanceof Blob;
};
